(() => {
  const markLoaded = (image) => {
    const wrapper = image.closest('.solo-image-loader');
    if (!wrapper || wrapper.classList.contains('solo-image-loader--loaded')) return;
    const minMs = Number.parseInt(getComputedStyle(wrapper).getPropertyValue('--solo-loader-min-ms'), 10) || 800;
    const startedAt = Number(wrapper.dataset.soloLoaderStartedAt || Date.now());
    const loadToken = wrapper.dataset.soloLoaderToken || '';
    const remaining = Math.max(0, minMs - (Date.now() - startedAt));
    window.setTimeout(() => {
      if (wrapper.dataset.soloLoaderToken === loadToken) {
        wrapper.classList.add('solo-image-loader--loaded');
      }
    }, remaining);
  };

  const watch = (image) => {
    if (!(image instanceof HTMLImageElement)) return;
    if (image.dataset.soloLoaderWatched === 'true') return;
    image.dataset.soloLoaderWatched = 'true';
    const wrapper = image.closest('.solo-image-loader');
    if (wrapper && !wrapper.dataset.soloLoaderStartedAt) {
      wrapper.dataset.soloLoaderStartedAt = String(Date.now());
      wrapper.dataset.soloLoaderToken = String(Date.now());
    }
    if (image.complete && image.naturalWidth > 0) markLoaded(image);
    else image.addEventListener('load', () => markLoaded(image), { once: true });
    image.addEventListener('error', () => markLoaded(image), { once: true });
    // A cloned or dynamically replaced image can occasionally miss the native
    // load event. Never leave the product card invisible indefinitely.
    window.setTimeout(() => markLoaded(image), 5000);
  };

  const scan = (root = document) => {
    if (root instanceof HTMLImageElement) watch(root);
    root.querySelectorAll?.('.solo-image-loader > img, .solo-image-loader > .product-media__image').forEach(watch);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  new MutationObserver((mutations) => mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.target instanceof HTMLImageElement) {
      const image = mutation.target;
      const wrapper = image.closest('.solo-image-loader');
      if (wrapper) {
        image.dataset.soloLoaderWatched = '';
        wrapper.classList.remove('solo-image-loader--loaded');
        wrapper.dataset.soloLoaderStartedAt = String(Date.now());
        wrapper.dataset.soloLoaderToken = String(Date.now());
        watch(image);
      }
      return;
    }
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) scan(node);
    });
  })).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'srcset']
  });
})();
